import React from 'react';

export const CARD_STYLES = {
    // Dark Styles
    'obsidian': { label: 'Obsidian Black', bg: 'linear-gradient(135deg, #1e293b, #0f172a)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 10px)' },
    'slate_pro': { label: 'Slate Professional', bg: 'linear-gradient(135deg, #334155, #475569)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px)' },
    'classic_navy': { label: 'Classic Navy', bg: 'linear-gradient(135deg, #0f172a, #1e3a8a)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)' },
    'charcoal_matte': { label: 'Charcoal Matte', bg: 'linear-gradient(135deg, #374151, #1f2937)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'url("/images/noise.png")' },
    'tech_blue': { label: 'Tech Blue', bg: 'linear-gradient(135deg, #2563eb, #7c3aed)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)' },
    'emerald': { label: 'Emerald City', bg: 'linear-gradient(135deg, #059669, #10b981)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.1) 2px, transparent 2.5px)' },
    'gold_rush': { label: 'Gold Rush', bg: 'linear-gradient(135deg, #d97706, #fbbf24)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'repeating-linear-gradient(-45deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 2px, transparent 2px, transparent 12px)' },
    'neon_night': { label: 'Neon Night', bg: 'linear-gradient(135deg, #db2777, #22d3ee)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'linear-gradient(0deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)' },
    'royal_purple': { label: 'Royal Purple', bg: 'linear-gradient(135deg, #5b21b6, #c026d3)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'radial-gradient(rgba(255,255,255,0.1) 2px, transparent 3px)' },

    // Light Styles
    'minimal_white': { label: 'Minimal White', bg: 'linear-gradient(135deg, #ffffff, #f1f5f9)', text: '#1e293b', border: 'rgba(0,0,0,0.1)', pattern: 'radial-gradient(rgba(0,0,0,0.03) 1px, transparent 1px)' },
    'azure_day': { label: 'Azure Day', bg: 'linear-gradient(135deg, #ffffff, #bfdbfe)', text: '#1e3a8a', border: 'rgba(30, 58, 138, 0.2)', pattern: 'repeating-linear-gradient(45deg, rgba(30, 58, 138, 0.02) 0px, rgba(30, 58, 138, 0.02) 1px, transparent 1px, transparent 10px)' },
    'red_accent': { label: 'Red Accent', bg: 'linear-gradient(135deg, #ffffff, #fecaca)', text: '#991b1b', border: 'rgba(153, 27, 27, 0.2)', pattern: 'radial-gradient(rgba(153, 27, 27, 0.05) 1px, transparent 1px)' },
    // Styles Spéciaux
    'carbon_fiber': { label: 'Carbon Fiber', bg: 'linear-gradient(135deg, #171717, #262626)', text: 'white', border: 'rgba(255,255,255,0.2)', pattern: 'repeating-linear-gradient(45deg, rgba(0,0,0,0.5) 0px, rgba(0,0,0,0.5) 2px, transparent 2px, transparent 4px)' },
    'holographic': { label: 'Holographic', bg: 'linear-gradient(135deg, #e0c3fc, #8ec5fc)', text: '#1e3a8a', border: 'rgba(255,255,255,0.5)', pattern: 'linear-gradient(45deg, rgba(255,255,255,0.4) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0.4) 75%, transparent 75%, transparent)' },
    'aurora': { label: 'Northern Lights', bg: 'linear-gradient(135deg, #0f172a, #1e1b4b)', text: '#a5f3fc', border: 'rgba(165, 243, 252, 0.3)', pattern: 'radial-gradient(circle at top right, rgba(56, 189, 248, 0.3), transparent 40%), radial-gradient(circle at bottom left, rgba(168, 85, 247, 0.3), transparent 40%)' },
};

export default function BusinessCard({
    formData,
    photoPreview,
    isActivated,
    rotation = { x: 0, y: 0 },
    isDragging = false,
    onMouseDown,
    qrCodeUrl,
    mode = '3d', // '3d', 'front', 'back'
    style = {},
    id
}) {
    const cardStyle = CARD_STYLES[formData.card_style] || CARD_STYLES['obsidian'];

    const Front = (
        <div style={{
            position: 'absolute', inset: 0, backfaceVisibility: 'hidden',
            background: cardStyle.bg,
            borderRadius: 16, border: `1px solid ${cardStyle.border}`,
            boxShadow: (mode === '3d' && isActivated) ? '0 0 30px rgba(59, 130, 246, 0.4)' : (mode === '3d' ? '0 10px 30px rgba(0,0,0,0.5)' : 'none'),
            padding: 20, display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
            color: cardStyle.text, overflow: 'hidden'
        }}>
            {/* Pattern Overlay */}
            <div style={{ position: 'absolute', inset: 0, backgroundImage: cardStyle.pattern, backgroundSize: '15px 15px', opacity: 0.3, pointerEvents: 'none' }} />

            {/* Watermark Logo - Right 60 */}
            <img src="/images/logoo.png" alt="Watermark" style={{
                position: 'absolute', right: 60, bottom: -30, height: 200,
                opacity: 0.05, filter: (cardStyle.text === 'white' || !CARD_STYLES[formData.card_style]) ? 'invert(1)' : 'grayscale(1)',
                transform: 'rotate(-15deg)', pointerEvents: 'none'
            }} />

            {/* Holographic Glare - Only for 3d active mode */}
            {mode === '3d' && (
                <div style={{
                    position: 'absolute', inset: -150,
                    background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.15) 45%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.15) 55%, transparent 60%)',
                    transform: `translateX(${rotation.y * 3}px) translateY(${rotation.x * 2}px)`,
                    opacity: Math.abs(rotation.y / 90) + Math.abs(rotation.x / 90) + 0.2,
                    pointerEvents: 'none'
                }} />
            )}

            {/* Main Logo - Top 25 Right 22 Height 90 */}
            <img src="/images/logoo.png" alt="Logo" style={{
                position: 'absolute', top: 25, right: 22, height: 90, zIndex: 3, objectFit: 'contain',
                filter: (cardStyle.text === 'white' || !CARD_STYLES[formData.card_style]) ? 'brightness(0) invert(1)' : 'grayscale(1)'
            }} />

            {/* Top Row (Badge) */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', zIndex: 2 }}>
                <div style={{ fontSize: '0.7rem', opacity: 0.7, border: '1px solid currentColor', padding: '2px 6px', borderRadius: 4 }}>
                    {formData.specialty || 'AGENT'}
                </div>
            </div>

            {/* Middle: Photo & Details */}
            <div style={{ display: 'flex', gap: 15, alignItems: 'center', zIndex: 2 }}>
                <div style={{
                    width: 70, height: 70, borderRadius: '50%', background: 'rgba(0,0,0,0.05)',
                    border: '2px solid currentColor', overflow: 'hidden', display: 'grid', placeItems: 'center',
                    flexShrink: 0
                }}>
                    {photoPreview ? (
                        <img src={photoPreview} alt="Agent" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                        <span style={{ fontSize: '1.5rem' }}>👤</span>
                    )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <div style={{ fontSize: '0.95rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '1px', lineHeight: 1 }}>
                        {formData.lastname || 'NOM'}
                    </div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 500, opacity: 0.9, marginBottom: 4 }}>
                        {formData.firstname || 'Prénom'}
                    </div>

                    {/* Stacked Contacts */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 3, fontSize: '0.7rem', opacity: 0.9, fontWeight: 600 }}>
                        {formData.phone && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                                {formData.phone}
                            </div>
                        )}
                        {formData.email && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                {formData.email}
                            </div>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                            www.infocolab.com
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom: Bio Description */}
            <div style={{ zIndex: 2, marginTop: 'auto', paddingTop: 10 }}>
                <div style={{ fontSize: '0.7rem', opacity: 0.7, fontStyle: 'italic', lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    "{formData.bio ? formData.bio : 'Votre pitch ici...'}"
                </div>
            </div>
        </div>
    );

    const Back = (
        <div style={{
            position: 'absolute', inset: 0, backfaceVisibility: 'hidden',
            transform: mode === '3d' ? 'rotateY(180deg)' : 'none',
            background: 'white', color: '#0f172a',
            borderRadius: 16, padding: 20,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            textAlign: 'center'
        }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '0.9rem', fontWeight: 800, textTransform: 'uppercase' }}>Scanner pour contact</h3>
            <div style={{ position: 'relative', width: 100, height: 100 }}>
                <img src={qrCodeUrl} alt="QR Code" style={{ width: '100%', height: '100%', mixBlendMode: 'multiply' }} />
                <div style={{
                    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                    width: 24, height: 24, background: 'white', borderRadius: 4, padding: 2,
                    boxShadow: '0 0 0 2px white'
                }}>
                    <img src="/images/logoo.png" alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
            </div>

            <div style={{ marginTop: 10, fontSize: '0.8rem', fontWeight: 600 }}>
                {formData.email || 'email@pro.com'}
            </div>
            <div style={{ fontSize: '0.8rem' }}>
                {formData.phone || '06 00 00 00 00'}
            </div>
            <div style={{ fontSize: '0.7rem', opacity: 0.6, marginTop: 4 }}>Region: {formData.city || 'Toute France'}</div>
        </div>
    );

    if (mode === 'front') return <div id={id} style={{ width: 350, height: 220, position: 'relative', overflow: 'hidden', ...style }}>{Front}</div>;
    if (mode === 'back') return <div id={id} style={{ width: 350, height: 220, position: 'relative', overflow: 'hidden', ...style }}>{Back}</div>;

    return (
        <div
            id={id}
            onMouseDown={onMouseDown}
            style={{
                width: 350, height: 220, position: 'relative',
                transformStyle: 'preserve-3d',
                transition: isDragging ? 'none' : 'transform 0.1s ease-out',
                transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
                cursor: isDragging ? 'grabbing' : 'grab',
                userSelect: 'none',
                ...style
            }}
        >
            {Front}
            {Back}
        </div>
    );
}
